/**
 * RTWO Indexer Engine — Null Event Bus Adapter
 */

import type { RTWOIndexJobType, RTWOIndexSourceType } from '../domain-models';
import type {
  EventBusAdapterStatus,
  EventIndexAdapterResult,
  IEventBusAdapter,
  IndexJobAdapterResult,
} from './event-bus-adapter-interface';

export class NullEventBusAdapter implements IEventBusAdapter {
  readonly adapterId = 'null-event-bus-adapter';
  readonly adapterName = 'Null Event Bus Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): EventBusAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async createIndexJob(
    _jobType: RTWOIndexJobType,
    _sourceType: RTWOIndexSourceType,
    _sourceReference: string
  ): Promise<IndexJobAdapterResult | null> {
    return null;
  }

  async indexEvent(
    _transactionHash: string,
    _blockNumber: number
  ): Promise<EventIndexAdapterResult | null> {
    return null;
  }
}
